import React from 'react';
import '../../styles/WhyChooseUs.css';
import whyImage from '../../assets/why-choose-us.png';

export default function WhyChooseUs() {
  return (
    <section className="why-section py-5">
      <div className="container">
        <div className="row align-items-center g-4">
          
          {/* Left Graphic */}
          <div className="col-lg-6">
            <img src={whyImage} alt="Why Choose Us" className="img-fluid rounded shadow-sm" />
          </div>

          {/* Right Content */}
          <div className="col-lg-6">
            <h2 className="section-title mb-3">Why Choose Us</h2>
            <p className="lead mb-4">
              With years of experience helping global companies expand into Malaysia, Reans Consulting provides unmatched reliability, local compliance expertise, and speed of execution to grow your workforce confidently.
            </p>
            <a href="/contact" className="btn btn-primary btn-lg">
              <i className="bi bi-person-check me-2"></i>Let’s Work Together
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
